import axios from 'axios'
import React, { useState, useEffect } from 'react'
import { TargetMargins } from '../components/TargetMargins/TargetMargins'
import { SingleProductCalculatorView } from './SingleProductCalculatorView'

export const SingleProductCalculator = () => {
    const [singleProductObj, setSingleProductObj] = useState({
        cost: 0,
        duty: 0,
        costPriceIncDuties: 0,
        packagingCost: 0,
        packagingWeight: 0,
        totalWeight: 0,
        productWeight: 0,
        currencyCode: 'gbp',
        packageType: 'packet',
        packaging: '333',
        originalCostPrice: 0,
        shippingCost: 0,
        bubbleWrapPieceCost: 0,
        largeLetter: false,
        bubbleWrapPieceWeight: 0,
    })
    const [exchangeRates, setExchangeRates] = useState()
    const [loaded, setLoaded] = useState(false)
    const [packaging, setPackaging] = useState()
    const [targetMargins, setTargetMargins] = useState({ gb: 30, eu: 30, us: 36, row: 36, ca: 35, au: 32 })
    const [shippingData, setShippingData] = useState({ GB: { totalCost: 0 }, US: { totalCost: 0 }, EU: { totalCost: 0 }, ROW: { totalCost: 0 }, CA: { totalCost: 0 }, AU: { totalCost: 0 } })
    const [exVatPrice, setExVatPrice] = useState({ GB: 0, ROW: 0, US: 0, EU: 0, CA: 0, AU: 0 })
    const [transactionFee, setTransactionFee] = useState({ GB: 0, ROW: 0, US: 0, EU: 0, CA: 0, AU: 0 })
    const [totalCost, setTotalCosts] = useState({ GB: 0, ROW: 0, US: 0, EU: 0, CA: 0, AU: 0 })
    const [regionalPrices, setRegionalPrices] = useState({ GB: 0, ROW: 0, US: 0, EU: 0, CA: 0, AU: 0 })
    const [gbpRegionalPrice, setGbpRegionalPrice] = useState({ GB: 0, ROW: 0, US: 0, EU: 0, CA: 0, AU: 0 })
    const [salesDutyFees, setSalesDutyFees] = useState({gb: 0, eu: 0, us: 0, row: 0, ca: 0, au: 0}) //this is fixed admin fee
    const [selectedDutyRate, setSelectedDutyRates] = useState({gb: 0, eu: 0, us: 0, row: 0, ca: 18, au: 0}) // this is % duty rates
    const [categoryDutyRateOptions, setCategoryDutyRateOptions] = useState({}) //this is the per category duty rates
    const [dutyAmounts, setDutyAmounts] = useState({gb: 0, eu: 0, us: 0, row: 0, ca: 0, au: 0}) //this is actual amounts being charged for duty in gbp
    

    //set initial target margins. Needs to be synced with figures in TargetMargins.js - not sure why
    useEffect(() => {
        setTargetMargins({ gb: 30, eu: 30, us: 36, row: 36, ca: 35, au: 32 })

        //fetch exchange rates and packaging
        const linksArr = [
            process.env.REACT_APP_HOST + 'api/exchangeRates/getLatest',
            process.env.REACT_APP_HOST + 'api/packaging/get',
            process.env.REACT_APP_HOST + 'api/shipping/getSalesDutyFees',
            process.env.REACT_APP_HOST + 'api/shipping/getDutyRates'
        ]
        axios.all(linksArr.map(l => axios.get(l)))
            .then(axios.spread((...res) => {
                console.log(...res)
                setExchangeRates(res[0].data)
                setPackaging(res[1].data)
                setSalesDutyFees(res[2].data)
                setCategoryDutyRateOptions(res[3].data)
                setLoaded(true)
                return res
            }))
            .then((res) => {
                //set initial packaging code/weight/cost from data fetched from server
                setSingleProductObj(prevState => ({
                    ...prevState,
                    packaging: res[1].data[0].manufacturerCode,
                    packagingWeight: res[1].data[0].weight,
                    packagingCost: res[1].data[0].cost,
                }))
            })
            .catch(error => {
                console.error("Error during API calls:", error);
            })
    }, [])

    //update price with duties whenever cost or duties change
    useEffect(() => {
        setSingleProductObj(prevState => ({
            ...prevState,
            costPriceIncDuties: singleProductObj.cost * (1 + (parseFloat(singleProductObj.duty) / 100))
        }))
    }, [singleProductObj.duty, singleProductObj.cost])

    useEffect(() => {
        //update cheapest shipping price and selling price
        const regionArr = ['gb', 'eu', 'row', 'us', 'ca', 'au']
        console.log(singleProductObj.packaging)
        for (const region of regionArr) {
            axios.post(process.env.REACT_APP_HOST + 'api/shipping/getCheapestShipping', {
                params: {
                    weight: singleProductObj.totalWeight,
                    region: region,
                    service: 'untracked',
                    largeLetter: singleProductObj.largeLetter,
                    packaging: singleProductObj.packaging
                }
            }).then((res) => {
                setShippingData(prevState => ({
                    ...prevState,
                    [res.data.country]: res.data
                }))
                return res
            })
        }
    }, [singleProductObj.packagingWeight, singleProductObj.productWeight, singleProductObj.totalWeight, singleProductObj.largeLetter])

    //get selling prices in (gbp ex vat)
    useEffect(() => {
        axios.post(process.env.REACT_APP_HOST + 'api/shipping/getSellingPrice', {
            params: {
                totalCost: totalCost, //array in format [{us: 34.21, gb: 23.33}]
                targetMargins: targetMargins, //array in format [{gb: 30, us: 36}]
                dutyRates: selectedDutyRate
            }
        }).then((res) => {
            Object.keys(targetMargins).forEach((region) => {
                setExVatPrice(prevState => ({
                    ...prevState,
                    [region.toUpperCase()]: res.data[region].salePrice
                }))
                setRegionalPrices(prevState => ({
                    ...prevState,
                    [region.toUpperCase()]: res.data[region].regional
                }))
                setGbpRegionalPrice(prevState => ({
                    ...prevState,
                    [region.toUpperCase()]: res.data[region].gbpRegionalPrice
                }))
                setTransactionFee(prevState => ({
                    ...prevState,
                    [region.toUpperCase()]: res.data[region].transactionFee
                }))
                // setDutyAmounts(prevState => ({
                //     ...prevState,
                //     [region.toLowerCase()]: res.data[region].dutyAmounts
                // }))
            })
        })

    }, [totalCost, targetMargins, selectedDutyRate])

    //update total costs whenever a component cost is updated
    useEffect(() => {
        const regionArr = Object.keys(targetMargins)
        for (const region of regionArr) {
            let sumTotalOfCosts = 0
            sumTotalOfCosts += singleProductObj.costPriceIncDuties
            sumTotalOfCosts += shippingData[region.toUpperCase()].totalCost
            sumTotalOfCosts += singleProductObj.packagingCost
            sumTotalOfCosts += singleProductObj.bubbleWrapPieceCost
            sumTotalOfCosts += salesDutyFees[region]
            console.log(dutyAmounts[region])
            //sumTotalOfCosts += dutyAmounts[region]
            

            setTotalCosts(prevState => ({
                ...prevState,
                [region.toUpperCase()]: sumTotalOfCosts
            }))
        }
    }, [singleProductObj.costPriceIncDuties, singleProductObj.packagingCost, shippingData, targetMargins])



    //updates target margin state from child component to state held here
    const callChildTargetMargin = (targetMargins) => {
        setTargetMargins(targetMargins)
    }


    const onChangeInput = (e) => {
        e.persist()
        let value = e.target.value
        //treat numbers as numbers
        const numbers = ['cost', 'duty', 'productWeight']
        if (numbers.includes(e.target.name)) {
            value = Number(e.target.value)
        }
        if (e.target.value === 'true') { value = Boolean(true) }
        if (e.target.value === 'false') { value = Boolean(false) }



        setSingleProductObj(prevState => ({
            ...prevState,
            [e.target.name]: value
        }))


        //update totalWeight if productWeight changed
        if (e.target.name === 'productWeight') {
            setSingleProductObj(prevState => ({
                ...prevState,
                totalWeight: parseFloat(e.target.value) + parseFloat(singleProductObj.packagingWeight)
            }))
        }

        //store original input cost price for xr conversion purposes
        if (e.target.name === 'cost') {
            setSingleProductObj(prevState => ({
                ...prevState,
                originalCostPrice: value
            }))
        }
    }

    const onChangeCurrencyCode = (e) => {
        e.persist()
        let rate = 0
        if (e.target.value === 'gbp') {
            rate = 1
        } else if (e.target.value === 'eu') {
            rate = exchangeRates.eu.currencyValue
        } else if (e.target.value === 'usd') {
            rate = exchangeRates.us.currencyValue
        }

        setSingleProductObj(prevState => ({
            ...prevState,
            cost: (singleProductObj.originalCostPrice / rate),
            currencyCode: e.target.value
        }))
    }


    const onChangePackaging = (e) => {
        e.persist()
        //look up weight for selected packaging
        const packagingManufacturerCode = e.target.value
        const bubbleWrap = packaging.filter((packet) => {
            return packet.packagingType === 'bubbleWrapPiece'
        })
        const selected = packaging.filter((packet) => {
            return packet.manufacturerCode === packagingManufacturerCode
        })


        let bubbleWrapCost = 0
        let bubbleWrapWeight = 0
        console.log(selected[0].packagingType)
        if (selected[0].packagingType === 'box') {
            console.log(bubbleWrap[0])
            bubbleWrapCost = bubbleWrap[0].cost
            bubbleWrapWeight = bubbleWrap[0].weight
        }


        setSingleProductObj(prevState => ({
            ...prevState,
            packaging: e.target.value.manufacturerCode,
            packagingWeight: selected[0].weight,
            totalWeight: parseFloat(singleProductObj.productWeight) + parseFloat(selected[0].weight),
            packagingCost: selected[0].cost,
            bubbleWrapPieceCost: bubbleWrapCost,
            bubbleWrapPieceWeight: bubbleWrapWeight
        }))
    }

    // const onChangeCanadaSalesDutyRate = (e) => {
    //     console.log(e.target.value, 'test')
    //     setSelectedDutyRates(prevState => ({
    //         ...prevState,
    //         ['ca']: parseFloat(e.target.value) // update canada duty rate to state
    //     }))
    // }


    return <div>
        <TargetMargins
            callChildTargetMargin={callChildTargetMargin}
            startingTargetMargins={targetMargins}

        />
        <SingleProductCalculatorView
            targetMargins={targetMargins}
            singleProductObj={singleProductObj}
            onChangeInput={onChangeInput}
            exchangeRates={exchangeRates}
            loaded={loaded}
            onChangeCurrencyCode={onChangeCurrencyCode}
            packaging={packaging}
            onChangePackaging={onChangePackaging}
            shippingData={shippingData}
            exVatPrice={exVatPrice}
            transactionFee={transactionFee}
            totalCost={totalCost}
            regionalPrices={regionalPrices}
            gbpRegionalPrice={gbpRegionalPrice}
            salesDutyFees={salesDutyFees} //fixed admin fees
            dutyRates={selectedDutyRate} //% duty rates
            dutyAmounts={dutyAmounts}
            //onChangeCanadaSalesDutyRate={onChangeCanadaSalesDutyRate}
            categoryDutyRateOptions={categoryDutyRateOptions}
        />
    </div>
}